module.exports = "<light-core-selector class=\"u-block\" active-index=\"{{currentIndex}}\" on-selected-index-change=\"_onSelectedIndexChange\" on-items-change=\"_onItemsChange\" >\n\t<content></content>\n</light-core-selector>";
